export default "__VITE_ASSET__D09Hijiu__"